import {useMutation} from '@tanstack/react-query';
import {APIError} from 'data/errors/api-error';
import {HttpStatusCode} from 'data/protocols/http/http-client';
import {queryClient} from 'infra/libs/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {translations} from 'presentation/translations-new';
import {putRefundBankData} from '../../services/putRefundBankData';
import {PutBeneficiaryBankDataMutationProps} from './types';
import {useRegistrationUpdateStatusStore} from 'presentation/pages/private/store/useRegistrationUpdateStatusStore';

const {errorAlert} = translations['pt-br'].privateFlow.profile.changeData;

export function usePutBeneficiaryBankDataMutation({
	handleChangeForm,
	setErrorMessage,
}: PutBeneficiaryBankDataMutationProps) {
	const {setNeedsUpdate} = useRegistrationUpdateStatusStore();

	return useMutation({
		mutationFn: putRefundBankData,
		onSuccess: data => {
			queryClient.setQueryData([QUERY_KEYS.BENEFICIARY_BANK_DATA], data);
			handleChangeForm();

			queryClient.setQueryData([QUERY_KEYS.REGISTRATION_UPDATE_STATUS], {
				necessitaAtualizacao: false,
			});
			setNeedsUpdate(false);
		},
		onError: err => {
			if (err instanceof APIError && err.statusCode === HttpStatusCode.preconditionFailed) {
				setErrorMessage(err?.message);

				return;
			}
			setErrorMessage(errorAlert);
		},
	});
}
